import { buildProps } from '@xzx-design/utils'

import type { ExtractPropTypes } from 'vue-demi' // test vue-demi
import type Divider from './divider.vue'

export const dividerProps = buildProps({
  contentPosition: {
    type: String,
    values: ['left', 'right'],
    default: '',
  },
  vertical: {
    type: Boolean,
    default: false,
  },
  dashed: {
    type: Boolean,
    default: false,
  },
  margin: {
    type: Boolean,
    default: true,
  },
})

export type DividerProps = ExtractPropTypes<typeof dividerProps>
export type DividerInstance = InstanceType<typeof Divider>
